import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'openDemoProjectEditor',
  'translateYourVideoClick',
  'translateYourVideoEditorDemoClick',
  'upgradeApplyChangesEditorDemoClick',
  'onboardingFinishedEditorDemo',
  'upgradePlanAccountPageDemo',
  'dashboardOpenTrial',
  'trialProjectOpen',
  'trialProcessingScreenView',
  'upgradeVoiceCloneAccountClick',
  'downloadButtonClick',
  'videoOptionDownloadClick',
  'videoWithSubtitlesOptionDownloadClick',
  'videoWithLipsyncOptionDownloadClick',
  'audioOptionDownloadClick',
  'srtOptionDownloadClick',
  'upgradeToTranslateFullPlayerClick',
  'applyChangesTrialProjectClick',
] as const;

export const demoProjectsTrial = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
